const Socials = ({ socials, setSocials }) => {
  return (
   <div className="flex flex-col gap-6 p-6 mx-auto max-w-4xl bg-white rounded-2xl border border-gray-200 shadow-sm">
  {/* Header with icon */}
  <div className="flex items-center gap-3">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    </div>
    <div>
      <h3 className="text-lg font-semibold text-gray-900">Social Links</h3>
      <p className="text-sm text-gray-500 mt-0.5">You may provide links to your social media accounts. All fields are optional.</p>
    </div>
  </div>

  {/* Inputs container */}
  <div className="grid grid-cols-2 gap-4">
    {/* Facebook */}
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-medium text-gray-700">Facebook URL</label>
      </div>
      <input
        type="url"
        placeholder="https://facebook.com/username"
        value={socials.facebook || ""}
        onChange={(e) => setSocials({ ...socials, facebook: e.target.value })}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Instagram */}
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-medium text-gray-700">Instagram URL</label>
      </div>
      <input
        type="url"
        placeholder="https://instagram.com/username"
        value={socials.insta || ""}
        onChange={(e) => setSocials({ ...socials, insta: e.target.value })}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* LinkedIn */}
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-medium text-gray-700">LinkedIn URL</label>
      </div>
      <input
        type="url"
        placeholder="https://linkedin.com/in/username"
        value={socials.linkedin || ""}
        onChange={(e) => setSocials({ ...socials, linkedin: e.target.value })}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* ResearchGate */}
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-medium text-gray-700">ResearchGate URL</label>
      </div>
      <input
        type="url"
        placeholder="https://researchgate.net/profile/username"
        value={socials.researchgate || ""}
        onChange={(e) => setSocials({ ...socials, researchgate: e.target.value })}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* IEEE - full width */}
    <div className="flex flex-col gap-1.5 col-span-2">
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-medium text-gray-700">IEEE URL</label>
      </div>
      <input
        type="url"
        placeholder="https://ieeexplore.ieee.org/author/xxxx"
        value={socials.ieee || ""}
        onChange={(e) => setSocials({ ...socials, ieee: e.target.value })}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>
  </div>
</div>
  );
};

export default Socials;
